<script setup lang="ts">
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import {
  useCancelKollegeUserCourseMutation,
  useUserCourseCancelViewQuery,
} from './UserCourseCancelView.generated'
import { useRoute } from 'vue-router'
import { useAlert } from '@/libs/alertPortal'

const route = useRoute('OkaneKollegeUserCourseCancel')

const query = useUserCourseCancelViewQuery({
  userId: route.params.userId,
})

const alert = useAlert()

const cancelMutation = useCancelKollegeUserCourseMutation()

const handleCancelButtonClick = async () => {
  const standardCourse = query.result.value?.kollegeUser?.standardCourse
  if (standardCourse == null) {
    throw new Error('standard course not found')
  }

  if (!window.confirm('解約を確定します。よろしいですか？')) {
    return
  }

  try {
    await cancelMutation.mutate({
      input: {
        userCourseID: standardCourse.id,
      },
    })

    alert.success('解約処理を完了しました')
  } catch (error) {
    console.error(error)
    alert.error('解約処理に失敗しました')
  }
}
</script>

<template>
  <section
    v-if="query.loading.value || query.result.value?.kollegeUser == null"
  >
    <p>読み込み中...</p>
  </section>
  <section v-else-if="query.result.value.kollegeUser.standardCourse == null">
    <p>契約していないユーザーです</p>
  </section>
  <section
    v-else-if="
      query.result.value.kollegeUser.standardCourse.status === 'CANCELLED'
    "
  >
    <p>解約済みのユーザーです</p>
  </section>
  <section v-else :class="$style.main">
    <SectionTitle :class="$style.title">解約の確定</SectionTitle>
    <p :class="$style.description">
      このユーザーの解約処理を確定します。<br />
      以下の対応を行ったことを確認し、解約を確定してください。
    </p>
    <div :class="$style.todo">
      <p :class="$style.todoTitle">TODO</p>
      <ul>
        <li>ユーザーのメールに一次返信</li>
        <li>
          経理に返金申請
          <ul>
            <li>返金申請の中の返金額計算ロジックは利用規約に基づく</li>
          </ul>
        </li>
      </ul>
    </div>
    <div :class="$style.buttonGroup">
      <FlatButton
        variant="caution"
        @click="handleCancelButtonClick"
        :disabled="cancelMutation.loading.value"
      >
        解約を確定
      </FlatButton>
    </div>
  </section>
</template>

<style lang="scss" module>
.main {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.title {
  padding-bottom: 24px;
  border-bottom: 1px solid $color-border-low-emphasis;
}

.description {
  font-size: 16px;
  line-height: 1.8;
}

.todo {
  padding: 16px;
  border-radius: 12px;
  background-color: $color-surface-accent-red-light;

  ul {
    margin-left: 16px;

    li {
      list-style: disc;
      margin-top: 8px;
      font-size: 16px;
      line-height: 1.8;
    }
  }
}

.todoTitle {
  font-size: 12px;
  font-weight: bold;
}

.buttonGroup {
  display: flex;
  justify-content: flex-end;
}
</style>
